import { useNavigation } from '@pankod/refine-core';
import { ListButton, EditButton, DeleteButton, Space } from '@pankod/refine-antd';

type PageHeaderProps = {
  path: string;
};

export const PageHeader: React.FC<PageHeaderProps> = (props) => {
  const { push } = useNavigation();
  return (
    <Space>
      <ListButton />
      <EditButton />
      <DeleteButton onSuccess={() => push(props.path)} />
    </Space>
  );
};
